import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { requestPlant as request } from 'api/common';
import { getLoginInform } from 'function/login';
import useLoginState from 'global/loginState';
import usePlantsState from 'global/plantState';
import { RETURN_YN } from 'types/type';
import isEmpty from 'utils/isEmpty';
import pluck from 'utils/array/pluck';

/**
 * 공장 목록
 */
function usePlantState() {
  /* variable */
  const loginInform = getLoginInform();

  /* router */
  const { pathname } = useLocation();

  /* recoil */
  const { setLogin } = useLoginState();
  const { plant, setPlant } = usePlantsState();

  /* watch */
  useLayoutEffect(() => {
    requestPlant();
  }, [pathname]);
  useEffect(() => {
    if (!isEmpty(loginInform) && loginInform.adminYn !== RETURN_YN.Y) {
      setLogin({
        pltCd:
          plant.alls.find(({ seq } = {}) => seq === loginInform.fatoryCodeSeq)
            ?.pltCd ?? ''
      });
    }
  }, [plant.alls]);

  /* method */
  // 공장 목록 조회 요청
  const requestPlant = async () => {
    const { list = [] } = await request();
    const { authList = [] } = loginInform;

    setPlant({
      alls: list,
      hasReads: list.filter(({ pltCode } = {}) =>
        pluck(
          authList.filter(({ readYn } = {}) => readYn === RETURN_YN.Y),
          'pltCode'
        ).includes(pltCode)
      ),
      hasMods: list.filter(({ pltCode } = {}) =>
        pluck(
          authList.filter(({ modYn } = {}) => modYn === RETURN_YN.Y),
          'pltCode'
        ).includes(pltCode)
      ),
      koreas: list.filter(({ seq } = {}) => [1, 2].includes(seq))
    });
  };
}

export default usePlantState;
